/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BaseChipSelectorZoneTooltipEnum {
    UNKNOWN = '',
    STATIC = 'STATIC',
    DYNAMIC = 'DYNAMIC'
}
